'use client';
import React, { useState } from 'react';
import { logEvent } from '@utils/googleAnalytics';
import Link from 'next/link';
import { getAppRoute } from '@utils/getAppRoute';
import { Desktop } from '@components/Desktop';
import cn from './style.module.scss';
interface Tab {
  title: { main: string; sub: string };
  imageBig: string;
  imageSmall: string;
}

const ExperienceTab: React.FC<{ t: any }> = (props) => {
  const { t } = props;
  const [activeTab, setActiveTab] = useState<number>(0);
  const [hoveredTab, setHoveredTab] = useState<number | null>(null);

  const tabs: Tab[] = [
    {
      title: { main: t['experienceTab1main'], sub: t['experienceTab1sub'] },
      imageBig:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_1.webp',
      imageSmall:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_2.webp',
    },
    {
      title: { main: t['experienceTab2main'], sub: t['experienceTab2sub'] },
      imageBig:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_1.webp',
      imageSmall:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_2.webp',
    },
    {
      title: { main: t['experienceTab3main'], sub: t['experienceTab3sub'] },
      imageBig:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_1.webp',
      imageSmall:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_2.webp',
    },
    {
      title: { main: t['experienceTab4main'], sub: t['experienceTab4sub'] },
      imageBig:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_1.webp',
      imageSmall:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_2.webp',
    },
    {
      title: { main: t['experienceTab5main'], sub: t['experienceTab5sub'] },
      imageBig:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_1.webp',
      imageSmall:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_2.webp',
    },
    {
      title: { main: t['experienceTab6main'], sub: t['experienceTab6sub'] },
      imageBig:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_1.webp',
      imageSmall:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_2.webp',
    },
    {
      title: { main: t['experienceTab7main'], sub: t['experienceTab7sub'] },
      imageBig:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_1.webp',
      imageSmall:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_2.webp',
    },
    {
      title: { main: t['experienceTab8main'], sub: t['experienceTab8sub'] },
      imageBig:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_1.webp',
      imageSmall:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_2.webp',
    },
    {
      title: { main: t['experienceTab9main'], sub: t['experienceTab9sub'] },
      imageBig:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_1.webp',
      imageSmall:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_2.webp',
    },
    {
      title: { main: t['experienceTab10main'], sub: t['experienceTab10sub'] },
      imageBig:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_1.webp',
      imageSmall:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_2.webp',
    },
    {
      title: { main: t['experienceTab11main'], sub: t['experienceTab11sub'] },
      imageBig:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_1.webp',
      imageSmall:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_2.webp',
    },
    {
      title: { main: t['experienceTab12main'], sub: t['experienceTab12sub'] },
      imageBig:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_1.webp',
      imageSmall:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_2.webp',
    },
    {
      title: { main: t['experienceTab13main'], sub: t['experienceTab13sub'] },
      imageBig:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_1.webp',
      imageSmall:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_2.webp',
    },
    {
      title: { main: t['experienceTab14main'], sub: t['experienceTab14sub'] },
      imageBig:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_1.webp',
      imageSmall:
        'https://asset.aldar.com/damascus/gallery/launches/arthouse/experience_tab_2.webp',
    },
  ];

  /*const handleFindOutMoreClick = () => {
    logEvent({
      event: 'click',
      additionalInfo: {
        link_id: 'launch-find-out-more-click',
      },
    });
  }; */

  return (
    <div className={cn.experienceBlock}>
      <div className={cn.experienceStory}>
        <div className={cn.experienceBig}>
          <img
            src={tabs[hoveredTab !== null ? hoveredTab : activeTab].imageBig}
            alt={tabs[hoveredTab !== null ? hoveredTab : activeTab].title.main}
          />
        </div>
        <div className={cn.experienceSmall}>
          <img
            src={tabs[hoveredTab !== null ? hoveredTab : activeTab].imageSmall}
            alt={tabs[hoveredTab !== null ? hoveredTab : activeTab].title.main}
          />
        </div>
      </div>
      <div className={cn.experienceContent}>
        <ul className={cn.experienceList}>
          {tabs.map((tab, index) => (
            <li key={index}>
              <div
                className={cn.listElement}
                onMouseEnter={() => setHoveredTab(index)}
                onMouseLeave={() => setHoveredTab(null)}
                onClick={() => setActiveTab(index)}
              >
                <div className={cn.listElement__item}>
                  <h3>{tab.title.main}</h3>
                </div>
                <Desktop>
                  <div className={cn.listElement__item}>
                    <h5>{tab.title.sub}</h5>
                  </div>
                </Desktop>
              </div>
            </li>
          ))}
        </ul>
        {/*<div className={cn.experienceSubmit}>
          <Link
            href={getAppRoute('HOME')}
            className={cn.findMore}
            onClick={handleFindOutMoreClick}>
            Find out more
          </Link>
        </div>*/}
      </div>
    </div>
  );
};

export default ExperienceTab;
